import React from 'react';

export default function FigureBlock({ num, title, kind = 'Render', agent, prompt, children }) {
  return (
    <figure className="figure" style={{ margin: '8px 0 36px' }}>
      <div className="figure-h">
        <span className="num">Fig. {num}</span>
        <span className="title">{title}</span>
      </div>
      <div className="figure-body">{children}</div>
      <figcaption className="figure-foot">
        <span className="badge"><span className="dot" />{(kind || 'Render').toUpperCase()}</span>
        {prompt && <span className="prompt">"{prompt}"</span>}
        {agent && <span className="by">{agent.toUpperCase()}</span>}
      </figcaption>
    </figure>
  );
}
